import { Box, Button, iconButtonClasses } from "@mui/material";
import styled from "styled-components";

export const PDFContainer = styled(Box)`
  width: 100%;
  height: 60vh; 
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  padding: 16px;

  .react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .react-pdf__Page {
    margin-bottom: 16px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    
    canvas {
      max-width: 100% !important;
      height: auto !important;
    }
  }
`;

export const FooterContainer = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 16px;
`;

export const BaseIconModal = styled.div`
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	cursor: pointer;
	z-index: 10;
  border-radius: 50%;

	svg {
		width: 20px;
		height: 20px;
		fill: ${({ theme }) => theme.figma.system.text};
	}
`;

export const AreaIconCloseModal = styled(BaseIconModal)`
	position: absolute;
	top: 5px;
	right: 5px;

	&&& {
		& .${iconButtonClasses.root} {
			width: 100%;
			height: 100%;
			padding: 0;
		}
		& .${iconButtonClasses.disabled} {
			opacity: 0.2;
			cursor: not-allowed;
		}
	}
`;

export const ContainerModal = styled.div`
  padding-top: 15px;
`;

export const ButtonDontShowMeAgain = styled(Button)`
  text-decoration: underline !important;
  color: ${({ theme }) => theme.black} !important;
  font-size: 0.8125rem !important;
  text-transform: none !important;

  &:disabled {
    opacity: 0.5;
  }
`;